import { Box, styled } from '@mui/material'
import { TopBarUserVisibilityType } from '../../types'
import { TopBarLanguageSelect } from '../top-bar-language-select'
import { TopBarUserNameWrapper } from '../top-bar-user-name-wrapper'
import { MobileLogoutLink } from './mobile-logout-link'

const SectionContentBox = styled(Box)({
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  position: 'fixed',
  padding: '1rem'
})

const LanguageSectionBox = styled(Box)({
  marginBottom: '2rem'
})

type MobileLangAndUserProps = TopBarUserVisibilityType

export const MobileLangAndUser = ({ showUserName }: MobileLangAndUserProps) => {
  return (
    <SectionContentBox component="div">
      <LanguageSectionBox component="div">
        <TopBarLanguageSelect isMobile />
      </LanguageSectionBox>
      <Box component="div">
        <TopBarUserNameWrapper isMobile={true} showUserName={showUserName} />
      </Box>
      <Box component="div">
        <MobileLogoutLink />
      </Box>
    </SectionContentBox>
  )
}
